
var  _customer_id = is_empty(__st.cid) ? "" : __st.cid;

var lib_mobile_device = {

  get_app_configs : function(){

    var app_configs = Object();

    var appview_hash = "#appview:";
    var appview_replace_hash = "#appview_r:";

    ///////////////// NAMEs
    var names = Object();
    names.appview_hash = appview_hash;
    names.checkouts_path = "/checkouts/";

    ///////////////////URLs
    var urls = Object();
    urls.appbar_search = "https://www.cconmausa.com/search?view=appview";
    urls.appbar_cart = "https://www.cconmausa.com/cart?view=appview";
    app_configs.urls = urls;

    /////////////////
    var appview_paths = [];
    var  obj = Object();
    obj.title = " ";
    obj.path = "/products/";
    appview_paths.push(obj);

    obj = Object();
    obj.title = "";
    obj.path = "com/search";
    appview_paths.push(obj);

    obj = Object();
    obj.title = encodeURI("나의 주문내역");
    obj.path = "/account/?name=";
    appview_paths.push(obj);

    obj = Object();
    obj.title = encodeURI("앱설치안내");
    obj.path = "/pages/app_install";
    appview_paths.push(obj);

    obj = Object();
    obj.title = encodeURI("카톡친구");
    obj.path = "/pages/kakaoplus";
    appview_paths.push(obj);

    obj = Object();
    obj.title = encodeURI("주문결제");
    obj.path = "/checkouts/";
    obj.is_replace = true;
    appview_paths.push(obj);
    
    obj = Object();
    obj.title = encodeURI("문의");
    obj.path = "channel.io/user-chats/";
    appview_paths.push(obj);

    obj = Object();
    obj.title = encodeURI("주문결제");
    obj.path = "shop.app/pay/session/create_and_redirect";
    obj.is_replace = true;
    appview_paths.push(obj);
    /*
    obj = Object();
    obj.title = encodeURI("꽃송이지갑");
    obj.path = "/pages/gateway";
    appview_paths.push(obj);
    */
/*
    obj = Object();
    obj.title = encodeURI("주문확인");
    obj.path = "/orders/";
    appview_paths.push(obj);
*/


    //https://cusca3.cconmausa.com/wms/admin/light?ref=main

    app_configs.appview_paths = appview_paths;

    ///////////////////
    var appview_keep_paths = [];
    appview_keep_paths.push("/thank_you");
    appview_keep_paths.push("/checkouts/");
    appview_keep_paths.push("/invoices/");
    appview_keep_paths.push("/pages/gateway");
    appview_keep_paths.push("/wms/");
    appview_keep_paths.push("com/search");
    appview_keep_paths.push("/orders/");
    app_configs.appview_keep_paths = appview_keep_paths;




    return JSON.stringify(app_configs);
  },

 update_device_info : function(device_token,system_name,system_version,app_version)
  {

    //console.log("update_device_info() start");
    //console.log("device_token : " + device_token);
    //console.log("system_name : " + system_name);
    //console.log("system_version : " + system_version);
    //console.log("app_version : " + app_version);
    //console.log("customer_id : " + _customer_id);
    $.ajax
    ({
      type		: "POST",
      url		: _extapi_url,
      data		:
      {
        action: "update_device_info",
        device_token : device_token,
        customer_id : _customer_id,
        system_name : system_name,
        system_version : system_version,
        app_version : app_version
      },
      cache		: false,
      dataType	: "json",
      async		: true,
      success		: function(jsonData)
      {
        _console_log("jsonData.result_data : " + jsonData.result_data);
        if(jsonData.result_code == "S0000")
        {
        }
		else
        {
        }

      },
      error		: function(XMLHttpRequest, textStatus, errorThrown)
      {
        _console_log("Error code : " + XMLHttpRequest.status + "\n" +
              "message : " + textStatus.responseText + "\n" +
              "error : " + errorThrown);
      },
      complete : function()
      {

      }
    }); 
    
  }
  ,
  update_user_device_info : function(device_token,system_name,system_version,app_version,user_agent)
  {

    $.ajax
    ({
      type		: "POST",
      url		: _extapi_url,
      data		:
      {
        action: "update_device_info",
        device_token : device_token,
        customer_id : _customer_id,
        system_name : system_name,
        system_version : system_version,
        app_version : app_version,
        user_agent : user_agent
      },
      cache		: false,
      dataType	: "json",
      async		: true,
      success		: function(jsonData)
      {
        _console_log("jsonData.result_data : " + jsonData.result_data);
        if(jsonData.result_code == "S0000")
        {
        }
		else
        {
        }

      },
      error		: function(XMLHttpRequest, textStatus, errorThrown)
      {
        _console_log("Error code : " + XMLHttpRequest.status + "\n" +
              "message : " + textStatus.responseText + "\n" +
              "error : " + errorThrown);
      },
      complete : function()
      {

      }
    }); 
    
  },
  refresh_login_state : function(is_logged_in){
    _console_log("refresh_login_state() is_logged_in : " + is_logged_in);
   // $("#id_test").css("display","block");

    if(is_logged_in)
    {
      $(".top-mobile .top-notice-search-btn .top-notice-wrapper").css("display","inherit");
      $(".top-mobile .top-notice-search-btn .top-login-wrapper").css("display","none");
    }
    else
    {
      $(".top-mobile .top-notice-search-btn .top-notice-wrapper").css("display","none");
      $(".top-mobile .top-notice-search-btn .top-login-wrapper").css("display","inherit");
    }

  }

};
